import { useEffect, useMemo, useRef, useState } from "react"
import apis from "../../../api"
import { apiResult, formatDate, getUserSession, minuteToTime } from "../../../Utils/Common"
import { Alert, Avatar, Box, Button, IconButton, Paper, Tooltip, Typography } from "@mui/material"
import { BookOutlined, CalendarMonthOutlined, CommentOutlined, EditOutlined, InfoOutlined, ListOutlined, PersonOutline, PlusOne, PriceCheckOutlined, Remove, TimerOutlined, TrendingUp } from "@mui/icons-material"
import { getItemsFromObjects, loadCourseCategories } from "../../../Component/DataLoader"
import { CourseLoader } from "../../fragement/CourseSelector"
import Switch3 from "../../../Component/Switch3"
import CommonDialog from "../../../Component/CommonDialog"
import { MyTextField } from "../../../Component/MuiEx"

const NoteEditDialog = (props) => {
    const { onSubmit, title, errorHint, name, onClose, lines, defaultValue } = props
    const [content, setContent] = useState(defaultValue)
    const handleSubmit = () => {
        onSubmit && onSubmit(name, content)
    }
    return <CommonDialog onClose={onClose} onSubmit={handleSubmit} dialogTitle={title} errorHint={errorHint}>
        <Box sx={{ minWidth: "500px" }}>
            <MyTextField multiline={true} rows={lines ? lines : 1} fullWidth={true} defaultValue={defaultValue} name={name} onChange={(e) => { setContent(e.target.value) }} />
        </Box>
    </CommonDialog>
}
const AttendanceStatus = ["AB", "N/A", "AT"]
const AttendanceColors = ["#d32f2f", "#0288d1", "#2e7d32"]
const settleColors = ["#888", "#2e7d32"]

function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = useState(false);
  
    const observer = useMemo(
      () =>
        new IntersectionObserver(([entry]) =>
          setIsIntersecting(entry.isIntersecting),
        ),
      [],
    );
  
    useEffect(() => {
      observer.observe(ref.current);
  
      return () => {
        observer.disconnect();
      };
    }, [ref, observer]);
  
    return isIntersecting;
  }
const MemberCourseDailyCard = (props) => {
    const { record, classObj, memberCourse, date, onError, onHint, onNew } = props
    const [categories, setCategories] = useState()
    const [courses, setCourses] = useState()
    const [fields, setFields] = useState()
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState()
    const [course, setCourse] = useState()
    const [error,setError] = useState()
    const ref = useRef()
    const [editDialog, setEditDialog] = useState()
    const isInView = useIsInViewport(ref)
    getUserSession(apis)
    let loading = false
    useEffect(() => {
        if (loading) return
        loading = true
        loadCourseCategories(apis, (data) => setCategories(data), onError)
        CourseLoader((data) => setCourses(data), apis, false, onError)
    }, [])

    useEffect(() => {
        let cid = (record ? record : memberCourse)?.member_course?.course_package?.category_id
        let ccid = (record ? record : memberCourse)?.member_course?.course_package?.course_id
        if (cid > 0 && categories && courses) {
            setCategory(getItemsFromObjects(categories, cid))
            setCourse(getItemsFromObjects(courses, ccid))
        }
        record ? setFields({ ...record }) : setFields({
            id: 0,
            class_id: classObj?.id,
            class: classObj,
            score: 0,
            member: memberCourse?.member,
            member_course: memberCourse?.member_course,
            member_course_id: memberCourse?.member_course.id,
            sdate: date && formatDate(date.date),
            member_id: memberCourse?.member_id,
            attend_status: 0,
            attend_note: null,
            settle_fee: 0,
            settle_status: 0,
            settle_tax: 0,
        })
        
    }, [classObj, memberCourse, date, record])
    useEffect(()=>{
        setSelected(!record || (date && record.sdate == formatDate(date.date)))
    },[date])
    useEffect(() => {
        if (selected) {
            !isInView && ref.current?.scrollIntoView()
        }
    }, [selected])

    const handleCheckinChange = (n, v) => {
        if (v == -1) {
            handleEdit("attend_note", "Why absence?", 1, (n1, v1) => {
                let postData = setupPostData()
                postData[n] = v
                postData[n1] = (v1 == null ? undefined : v1)
                postChange(postData)
            })
        } else if (v == 1 && fields.member_course.course_package.billtype == 1) {
            handleEdit("settle_amount", "How many minutes is the lesson?", 1, (n1, v1) => {
                let postData = setupPostData()
                postData[n] = v
                postData[n1] = Number(v1)
                postData["settle_billtype"] = 1
                postChange(postData)
            })
        } else if (v == 1 && fields.member_course.course_package.billtype == 0) {
            let postData = setupPostData()
            postData[n] = v
            postData["settle_amount"] = 1
            postData["settle_billtype"] = 0
            postChange(postData)
        } else {
            let postData = setupPostData()
            postData[n] = v
            postData["settle_amount"] = 0
            postData["settle_billtype"] = 0
            postChange(postData)
        }
    }
    const postChange = (postData) => {
        let ff = postData.id > 0 ? apis.membersCourseRecordPut : apis.membersCourseRecordPost
        ff(postData).then(ret => {
            apiResult(ret, data => {
                if (postData.id > 0) {
                    setFields({ ...fields, ...postData })
                    onNew && onNew({ ...fields, ...postData })
                } else {
                    setFields({ ...fields, ...postData, id: data.id })
                    onNew && onNew({ ...fields, ...postData, id: data.id })
                }
                onHint && onHint("Save successfully")
            }, setError)
        })
        setEditDialog()
    }
    const setupPostData = () => {
        let postData = {}
        if (fields.id > 0) {
            postData.id = fields.id
            postData.attend_status = fields.attend_status
        } else {
            postData.class_id = fields.class_id
            postData.member_id = fields.member_id
            postData.member_course_id = fields.member_course_id
            postData.sdate = fields.sdate
        }
        return postData
    }
    const handleChange = (n, v) => {
        let postData = setupPostData()
        postData[n] = v
        postChange(postData)
    }
    const handleSettle = () => {
        setError()
        if (fields.attend_status == 1 || window.confirm("Does the user still need to settle the payment for the course missed?")) {
            apis.membersCourseRecordSettle({ id: fields.id, settle: 1 }).then(ret => {
                apiResult(ret, data => {
                    setFields({ ...fields, settle_status: data.settle_status })
                    onNew && onNew({ ...fields, settle_status: data.settle_status })
                },setError)
            })
        }
    }
    const handleEdit = (n, title, lines, callback = handleChange) => {
        setEditDialog(<NoteEditDialog onSubmit={callback} onClose={() => setEditDialog()} title={title} name={n} lines={lines} defaultValue={fields[n]} />)
    }
    return  <Box ref={ref} sx={{ ...props.sx, border: (record && record.sdate == formatDate(date?.date)) ? "2px solid #1976d243" : "", bgcolor: selected ? "#1976d211" : props.sx?.bgcolor, p: 1, mt: 0.5 }} >
        {fields &&<Box sx={{ display: "flex" }} onClick={() => { setSelected(!selected) }}>
            <CalendarMonthOutlined size="small" />
            <Typography sx={{ mt: 0.3, ml: 1 }}>{fields.sdate}</Typography>
            {!selected && <Typography sx={{ mt: 0.3, ml: 0.5 }}>({fields.class?.name})</Typography>}
            <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
            {!selected && <PersonOutline size="small" />}
            {!selected && fields.member && <Typography sx={{ mt: 0.3 }}>{fields.member.name}</Typography>}
            {selected && fields.class && <Typography sx={{ mt: 0.3 }}>{fields.class.name}</Typography>}
            <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
            <TimerOutlined size="small" />
            {fields.class && <Typography sx={{ mt: 0.3, ml: 1 }}>{minuteToTime(fields.class.begin_time)} - {minuteToTime(fields.class.end_time)}</Typography>}
            {!selected && <Avatar sx={{ width: "24px", height: "24px", fontSize: '12px', ml: 1, bgcolor: AttendanceColors[fields.attend_status + 1] }}>{AttendanceStatus[fields.attend_status + 1]}</Avatar>}
            {!selected && <Avatar sx={{ width: "24px", height: "24px", fontSize: '12px', ml: 1, color: "white", bgcolor: settleColors[fields.settle_status], border: "1px" }}>{fields.settle_amount>1?fields.settle_amount:<PriceCheckOutlined />}</Avatar>}
        </Box>}
        {fields && selected && <Box sx={{ bgcolor: "#fff", p: 1.5 }}>
            {error && <Alert severity={"error"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            <Box sx={{ display: "flex", pt: 2 }}>
                <PersonOutline size="small" />
                {fields.member && <Typography sx={{ mt: 0.3, ml: 1 }}>{fields.member.name}</Typography>}
                <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
                {fields.attend_status != 0 && <><Tooltip title="Attendance note"><InfoOutlined size="small" /></Tooltip>
                    <Typography sx={{ ml: 1, maxWidth: "50%" }}>{fields.attend_note ? fields.attend_note : "Add attendance note"}</Typography>
                    <Tooltip title="Edit the attendance note"><IconButton size="small" onClick={() => { handleEdit("attend_note", "Edit attendacne note", 1) }} sx={{ color: "#1976d2", mt: -0.5, ml: 1 }}><EditOutlined /></IconButton></Tooltip>
                    <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
                </>}
                <Switch3 name={"attend_status"} size={"small"} items={["AB", "NA", "AT"]} disabled={fields.settle_status != 0}
                    labels={["Absence", "N/A", "Attendence"]} values={[-1, 0, 1]} defaultValue={fields.attend_status} onChange={handleCheckinChange} />
                <Tooltip title={"settle down the lesson fee"}><Avatar onClick={handleSettle} disabled={fields.attend_status == 0} sx={{ width: "32px", cursor: "pointer", height: "32px", bgcolor: settleColors[fields.settle_status], fontSize: '12px', ml: 1, color: "white", border: "1px" }} size="small"><PriceCheckOutlined /></Avatar></Tooltip>
            </Box>
            {fields.attend_status != 0 && <Box sx={{ display: "flex", pt: 2 }}>
                <Tooltip title="Course name"><BookOutlined size="small" /></Tooltip>
                <Typography sx={{ mt: 0.3, ml: 1 }}>{category?.name} / {course ? course.name : "*"}</Typography>
                <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
                {fields.attend_status == 1 && <>
                    <Tooltip title="Performence"><TrendingUp size="small" /></Tooltip>
                    <Tooltip title="Performence"><Typography sx={{ ml: 1 }}>{record ? record.score : "N/A"}</Typography></Tooltip>
                </>}
                <Typography sx={{ flex: '1 1 5%', mt: 0.5 }} />
                {fields.member_course?.course_package?.billtype == 1 && <Tooltip title="Lesson duration"><Typography>{fields.settle_amount > 0 ? fields.settle_amount : 0.0} minutes</Typography></Tooltip>}
                {fields.member_course?.course_package?.billtype == 1 && <IconButton size="small" onClick={() => { handleEdit("settle_amount", "Edit lesson duration(minutes)", 1) }} sx={{ color: "#1976d2", mt: -0.5, ml: 1 }}><Tooltip title="Edit the lesson hours"><EditOutlined /></Tooltip></IconButton>}
                {fields.member_course?.course_package?.billtype == 0 && <Tooltip title="Lesson times"><Typography>{fields.settle_amount > 0 ? fields.settle_amount : 0} lesson(s)</Typography></Tooltip>}
                {fields.member_course?.course_package?.billtype == 0 && <IconButton size="small" disabled={fields.settle_status != 0} onClick={() => { handleEdit("settle_amount", "Edit lessons", 1) }} sx={{ color: "#1976d2", mt: -0.5, ml: 1 }}><Tooltip title="Edit the lesson time(s)"><EditOutlined /></Tooltip></IconButton>}
            </Box>}
            {fields.attend_status == 1 && <Box sx={{ display: "flex", pt: 2 }}>
                <Tooltip title="Lesson content"><ListOutlined size="small" /></Tooltip>
                <Typography sx={{ ml: 1, maxWidth: "45%" }}>{fields.content ? fields.content : "No content"}</Typography>
                {<IconButton size="small" onClick={() => { handleEdit("content", "Edit lesson content", 5) }} sx={{ color: "#1976d2", mt: -0.5, ml: 1 }}><Tooltip title="Write the lesson content"><EditOutlined /></Tooltip></IconButton>}
                <Typography sx={{ flex: '1 1 10%', mt: 0.5 }} />
                <Tooltip title="Lesson comment"><CommentOutlined size="small" /></Tooltip>
                <Typography sx={{ ml: 1, maxWidth: "45%" }}>{fields.comment ? fields.comment : "No comment"}</Typography>
                {<IconButton size="small" onClick={() => { handleEdit("comment", "Edit lesson comment", 5) }} sx={{ color: "#1976d2", mt: -0.5, ml: 1 }}><Tooltip title="Write the lesson comment"><EditOutlined /></Tooltip></IconButton>}
            </Box>}
        </Box>}
        {editDialog}
    </Box>

}
export default MemberCourseDailyCard